import Breadcrumb from "@/components/base/Breadcrumb";
import usePageTitle from "@/hooks/usePageTitle";

type Crumb = {
  label: string;
  to?: string;
};

type Props = {
  breadcrumb: Crumb[];
  eyebrow?: string;
  title: string;
  description?: string;
};

export default function PageHeader({ breadcrumb, eyebrow, title, description }: Props) {
  usePageTitle(title);
  return (
    <section className="border-b border-background-200 bg-background-100 px-4 md:px-8 py-10 md:py-14">
      <div className="mx-auto max-w-6xl flex flex-col gap-5">
        <Breadcrumb items={breadcrumb} />
        <div className="flex flex-col gap-3">
          {eyebrow && (
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-accent-600">
              <span className="w-5 h-px bg-accent-500" />
              {eyebrow}
            </span>
          )}
          <h1 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950">
            {title}
          </h1>
          {description && (
            <p className="max-w-3xl text-sm md:text-base leading-relaxed text-foreground-600">
              {description}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}